import { useSelector } from 'react-redux';
import { RootState } from '@store/types';
import { FeatureFlagsAvailable } from '@components/featureFlags';
import { SourceSystems } from '@helpers';

export const usePlanboardAvailable = () => {
  const featureFlags = useSelector<RootState>((state) => state.user.featureFlags ?? {});
  const connectorDetails = useSelector<RootState, any>((state) => state.membership.connectorDetails);

  const isFeatureEnabled = FeatureFlagsAvailable('machine-planboard', featureFlags);
  const sourceSystemType = connectorDetails?.code;

  return isFeatureEnabled && (sourceSystemType === SourceSystems.Bemet || sourceSystemType === SourceSystems.MKG);
};
